import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getJson } from './getJsonApi'
import { getBrowserLanguage } from '@/utils/get-browser-language'
import asset from './asset.json'
Vue.use(VueI18n)

const messages = {
  en: {
    ...asset.i18n.en
  },
  zh: {
    ...asset.i18n.zh_CN
  },
  th: {
    ...asset.i18n.th
  }
}
const language = getBrowserLanguage()
// i18n实例
const i18n = new VueI18n({
  locale: language,
  messages,
  silentTranslationWarn: true // 关闭控制台警告
})

export function loadLanguageAsync () {
  // 本地语言标识和远程区别
  const languageToJsonName = {
    en: 'en',
    zh: 'zh',
    th: 'th',
    id: 'id'
  }
  const locale = i18n.locale
  // 拿到远程文件
  return getJson(languageToJsonName[locale]).then(msgs => {
    i18n.mergeLocaleMessage(locale, msgs.data)
  })
}
export default i18n
